import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
function TokenomicsTabContant() {
  return (
    <>
      <div className="row align-items-center">
        <div className="col-md-7">
          <h1 className="banner-title mb-1 font-trajan">Tokenomics</h1>
          <h4 className="mb-5 font-trajan text-white">
            Cross-chain Interoperability :
          </h4>
          <ul className="text-white tabs-section-content-list">
            <li>
              <span>
                <BsArrowRight size="24" className="me-3" />
              </span>
              <Link to="#">https://debridge.finance</Link> liquidity transfers
              protocol (SDKS available)
            </li>
            <li>
              <span>
                <BsArrowRight size="24" className="me-3" />
              </span>
              Matterfi.com As a white label node, wallet and payment systems
            </li>
            <li>
              <span>
                <BsArrowRight size="24" className="me-3" />
              </span>
              Liquid pairings created at the exchange level
            </li>
            <li>
              <span>
                <BsArrowRight size="24" className="me-3" />
              </span>
              Circulating supply: 5 billion
            </li>
            <li>
              <span>
                <BsArrowRight size="24" className="me-3" />
              </span>
              Locked supply: 5 billion
            </li>
          </ul>
        </div>
        <div className="col-md-5">
          <img src="/assets/images/coins.png" className="img-fluid"></img>
        </div>
      </div>
    </>
  );
}

export default TokenomicsTabContant;
